// @ts-check
/**
 * src/lib/device-id.js
 *
 * Helper para generar y persistir un identificador único del navegador
 * actual en localStorage. Se usa para:
 *   - Lista de "dispositivos de confianza" en /configuracion
 *   - Detección de sesión nueva en logins (avisar al user por email
 *     si entró desde un device desconocido)
 *   - Telemetría/auditoría sin requerir cookies de tracking
 *
 * NO es PII — es un UUID v4 random generado del lado cliente.
 * Si el user borra localStorage, se genera uno nuevo (es por design,
 * para que no sea un fingerprint).
 */

const KEY = 'dr_victor_device_id';

export function getOrCreateDeviceId() {
  if (typeof window === 'undefined') return null;
  try {
    let id = window.localStorage.getItem(KEY);
    if (!id) {
      id = (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : `dev_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
      window.localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

export function readDeviceId() {
  if (typeof window === 'undefined') return null;
  try { return window.localStorage.getItem(KEY); } catch { return null; }
}
